import React from "react";
import { Link, useLocation } from "react-router-dom";
import AppLogo from "../../logo";

import { X } from "react-feather";

import * as Styles from "./styles";

const menuItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Projects", path: "/projects" },
  { label: "Clients", path: "/clients" },
];

const MobileMenu = ({ active, handleMobileMenu }) => {
  const { pathname } = useLocation();

  return (
    <Styles.Header active={active} aria-hidden={!active}>
      <Styles.Container className="container">
        <Styles.MobileMenuContainer>
          <Styles.CloseButton
            type="button"
            aria-label="Close menu"
            onClick={handleMobileMenu}
          >
            <X aria-hidden="true" />
          </Styles.CloseButton>
        </Styles.MobileMenuContainer>
        <Styles.Wtapper>
          <AppLogo />
          <Styles.MenuContainer aria-label="Main navigation">
            <Styles.MenuListWrapper>
              {menuItems.map((item, index) => (
                <Styles.MenuItem
                  key={item.path}
                  active={pathname === item.path}
                  open={active}
                  index={index}
                >
                  <Link to={item.path}>{item.label}</Link>
                </Styles.MenuItem>
              ))}
              <Styles.MenuItem
                active={pathname === "/contactus"}
                open={active}
                index={menuItems.length}
                className="button"
              >
                <Link to="/contactus">Contact us</Link>
              </Styles.MenuItem>
            </Styles.MenuListWrapper>
          </Styles.MenuContainer>
        </Styles.Wtapper>
      </Styles.Container>
    </Styles.Header>
  );
};

export default MobileMenu;
